import { FC } from "react";
import image from "../../Assets/TalentOnDemand/ai-person.png";
const TalentOnDemandFeaturesAI: FC = () => {
    return (
        <section
            className="w-full bg-black pt-10 px-5 lg:px-10"
        >
            <div className="w-full max-w-[1400px] mx-auto flex flex-col gap-5 items-center justify-center text-white">
                <div className="text-3xl md:text-5xl lg:text-7xl font-semibold">
                    Talent OnDemand <span className="text-brand-green">AI</span>
                </div>
                <span className="text-center w-full mx-auto md:w-fit text-white md:text-2xl mt-4">
                    Our cutting edge AI-based technology platform is<br className="hidden lg:block" /> revolutionizing the staffing and
                    recruitment landscape.
                </span>
                <div className="flex flex-col  items-center justify-center lg:justify-start lg:items-start lg:flex-row gap-5">
                    <div className="max-w-[350px] text-md lg:text-xl text-left  my-auto font-light">
                        Our
                        platform goes beyond the traditional resume offering a deeper understanding
                        of each candidate through a proprietary workplace personality assessment.
                    </div>

                    <div className="block lg:hidden max-w-[350px] text-md text-pretty my-auto font-light">
                        Mitigates bias and enable more successful and
                        quicker hires by providing a more comprehensive candidate profile.
                    </div>
                    <img src={image} alt="Person on phone" className="object-contain mt-auto max-h-[400px] -mx-10" />

                    <div className="hidden lg:block max-w-[350px] text-xl text-pretty my-auto font-light">
                        Mitigates bias and enable more successful and
                        quicker hires by providing a more comprehensive candidate profile.
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TalentOnDemandFeaturesAI;
